import React, { FC, useState, useEffect } from 'react';
import { Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useStore } from '@/components/store/Store';
import Container from '@/components/Container';
import { Domain } from '@/declarations/models/Domain';
import { Api } from '@/services/Api';

export const StatisticsView: FC = () => {
  const { t: tCommon } = useTranslation('common');
  const { state } = useStore();
  const selectedSiteId = state.selectedSite?.id ?? 0;
  const { selectedSiteData } = state;
  const [domain, setDomain] = useState<Partial<Domain>>();
  const [auth, setAuth] = useState<string>();
  const embedUrl = selectedSiteData?.content?.settings?.plausibleEmbedUrl || null;
  let siteFilter = `&f=is,props:site,${domain?.path || domain?.name}`;
  if (selectedSiteData?.content?.settings?.plausibleUniqueDomain) {
    siteFilter = '';
  }
  // let auth = selectedSiteData?.content?.settings?.plausibleAuth || null;
  const dynamicEmbedCompleteUrl = `https://plausible.io/share/${
    selectedSiteData?.content?.settings?.plausibleWebsiteId || domain?.name
  }?embed=true&background=transparent${siteFilter}&auth=${auth || 'MISSING AUTH (site settings)'}`;
  const handleDomainName = (name: string) => {
    const newdomain = {
      ...domain,
      name,
    };
    setDomain(newdomain);
  };

  useEffect(() => {
    if (selectedSiteId) {
      const ctx = Api.getDomainForSite(selectedSiteId || 0);
      ctx
        .fetchDirect(null)
        .catch((e) => console.error(e))
        .then((res) => {
          if (res) {
            setDomain(res);
            setAuth(selectedSiteData?.content?.settings?.plausibleAuth || '');
          }
        })
        .finally(ctx.abort);
    }
  }, [selectedSiteId]);

  useEffect(() => {
    if (domain?.name && domain.name.includes('localhost')) {
      // handleDomainName('exp.museum24.no');
    }
    if (domain?.name && domain.name.includes('exp.')) {
      setAuth('gFUyswZKMK_QrS5YhSoK_');
    }
    if (domain?.name && domain.name.includes('dev.')) {
      setAuth('zILQZ00iaHlKKP4K7dzwL');
    }
    if (domain?.name && domain.name.includes('beta.')) {
      setAuth('EJ7AyFauW2C5Srhlxr0o8');
    }
  }, [domain]);

  const isReady = !!((embedUrl || auth) && domain?.name);

  return (
    <Container p={4} gap={2} fullWidth fullHeight top left column>
      <Typography
        sx={{
          fontSize: '2rem',
          fontWeight: 400,
        }}>
        {tCommon('Statistics')}
      </Typography>

      <Typography>{tCommon('StatisticsIntro')}</Typography>

      {isReady && (
        <Container
          fullWidth
          fullHeight
          left
          column
          top
          sx={{ backgroundColor: '#efefef', padding: '1rem', overflow: 'auto' }}>
          {domain?.name && (
            <>
              <iframe
                loading='lazy'
                title='Plausible Statistics'
                src={auth ? dynamicEmbedCompleteUrl : `${embedUrl}&embed=true&background=transparent` || ''}
                style={{ border: 'none', width: '100%', height: '100%' }}
              />
              <script async src='https://plausible.io/js/embed.host.js' />
            </>
          )}
        </Container>
      )}
    </Container>
  );
};
